export default __webpack_public_path__ + "static/email-background-f50681734fe73facdc10d75875bc90a1.webp";